import React, {Component} from 'react';
import {addressSearchResponse, searchAddress} from '../../../actions/address.actions';
import {connect} from 'react-redux';
import {Button, PcBangPopup, Table} from '../PageComponents';
import MessageBox from '../MessageBox';

const stateToProps = state => {
  return {
    searchResult: state.address.searchResult,
  };
};

class AddressSearchModal extends Component {
  _search(e) {
    e.preventDefault();
    let searchKeyword = this.keyword.value;
    if (!searchKeyword || searchKeyword.length < 2) {
      this.props.dispatch(addressSearchResponse([]));
      return;
    }
    this.props.dispatch(searchAddress(searchKeyword));
  }

  _insertAddress(e, close, roadAddress, zipCode) {
    e.preventDefault();
    $(this.props.roadNameInputCssSelector)[0].value = roadAddress;
    $(this.props.zipCodeInputCssSelector)[0].value = zipCode;
    close();
  }

  render() {
    return (
      <PcBangPopup
        closeOnDocumentClick
        trigger={this.props.triggerButton}
        contentStyle={{width: '700px'}}
        title={'우편 번호 검색'}
        render={close => (
          <div>
            <div style={{marginBottom: '10px'}}>
              <label style={{display: 'none'}}>검색 키워드</label>
              <input
                name="roadNameOrLandLot"
                type="text"
                style={{width: '420px'}}
                ref={node => (this.keyword = node)}
                placeholder="2자리 이상의 도로명(예:강남대로 624) / 지번(예:신사동 502)"
                minLength="3"
              />
              <Button size={'small'} theme={'gray'} type="submit" onClick={e => this._search(e)}>
                우편 번호 검색
              </Button>
            </div>
            {this.renderSearchResult(close)}
          </div>
        )}
      />
    );
  }

  renderSearchResult(modalClose) {
    let searchResult = this.props.searchResult;
    if (searchResult.length == 0) {
      return (
        <MessageBox>
          검색 결과가 없습니다.
          <br />
          정확한 도로명+건물번호 또는 동·리+번지로 검색해 주시고,
          <br />
          다른 검색어 사용시 띄어쓰기에 유의하십시오.
        </MessageBox>
      );
    }
    return (
      <div style={{maxHeight: '400px', overflowY: 'scroll', fontSize: '14px'}}>
        <Table>
          {searchResult.map((address, index) => (
            <tr
              key={index}
              style={{cursor: 'pointer'}}
              onClick={e => this._insertAddress(e, modalClose, address.roadAddr, address.zipNo)}
            >
              <td>{address.zipNo}</td>
              <td>
                {address.roadAddr}
                <div style={{color: '#828282', marginTop: '5px'}}>{address.jibunAddr}</div>
              </td>
            </tr>
          ))}
        </Table>
      </div>
    );
  }
}

export default connect(stateToProps)(AddressSearchModal);
